export default "__VITE_ASSET__BkjeiFhK__"